/** Wire row from AIM GET /account/{type}/{id}/transactions. */
export interface AccountTransactionWire {
  transactionId: number | string;
  createdDate: string;
  amount: number;
  description: string;
  status: string;
  type?: string;
  merchant?: string;
  institution?: string;
}

/** Placeholder for one unusable AIM row; valid siblings remain renderable. */
export interface UnavailableAccountTransaction {
  unavailable: true;
  rowKey: string;
}

export type AccountTransactionRow = AccountTransactionWire | UnavailableAccountTransaction;

export function isUnavailableAccountTransaction(
  row: AccountTransactionRow
): row is UnavailableAccountTransaction {
  return 'unavailable' in row && row.unavailable === true;
}

export interface AccountTransactionsResultSet {
  count?: number;
  offset?: number;
  limit?: number;
  lastTransactionId?: number | string;
  allFetched: boolean;
}

export interface AccountTransactionsPayload {
  transactions: AccountTransactionRow[];
  resultSet: AccountTransactionsResultSet;
}

/** Valid outer AIM shape before individual transaction rows are normalized. */
export interface AccountTransactionsWirePayload {
  transactions: unknown[];
  resultSet: AccountTransactionsResultSet;
}

export interface GetAccountTransactionsOptions {
  lastTransactionId?: number | string;
  offset?: number;
  limit?: number;
  fromDate?: string;
  toDate?: string;
  status?: string;
}

export type TransactionDatePreset = 'all' | '30' | '90' | '365' | 'custom';
export type TransactionStatusFilter = 'all' | string;

export const TRANSACTION_PAGE_SIZE = 8;
export const TRANSACTION_FETCH_LIMIT = 8;

export interface TransactionAmountView {
  text: string;
  inflow: boolean;
}
